export default function PriceAutomation() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ④ 価格改定の自動化（超重要）
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div className="bg-white border-2 border-primary rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">リプライサー設計</h3>
            <div className="space-y-6">
              <div className="bg-primary/5 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 mb-4">価格ロジック例：</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-line text-primary text-xl mt-1"></i>
                    <span className="text-gray-700">最安値 - 10円</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-line text-primary text-xl mt-1"></i>
                    <span className="text-gray-700">ただし利益率20%以下にはしない</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-line text-primary text-xl mt-1"></i>
                    <span className="text-gray-700">ただし最安値が赤字なら追従しない</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col justify-center space-y-6">
            <div className="bg-gray-50 rounded-xl p-6">
              <h4 className="font-bold text-gray-900 mb-4">これを：</h4>
              <ul className="space-y-3">
                {['Keepa API', 'SP-API', 'Sheets + GAS'].map((item, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                      <i className="ri-check-line text-white"></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="bg-primary text-white rounded-xl p-6">
              <p className="text-lg font-medium">で自動更新。</p>
            </div>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-8 shadow-lg">
          <div className="flex items-center gap-4">
            <i className="ri-refresh-line text-5xl"></i>
            <div>
              <p className="text-3xl font-black mb-2">1日50回でも自動価格調整。</p>
              <p className="text-lg opacity-90">人間には不可能な頻度で最適価格を維持</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
